// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ec7ab8f5","430":"41081080","496":"13463871"}[chunkId] + ".chunk.js";
};